import { Injectable } from '@angular/core';
import { Observable,Subject} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MessageService {

  public storage: any;
  public constructor() { }
}
